import { selectAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: selectAnatomy.keys(),
  base: {
    trigger: {
      ...interactiveTransition,
    },
    // Chakra base puts Select.content on l2 (controls tier); we lift it to
    // l3 so the dropdown reads as the same kind of floating surface as
    // Menu/Popover/HoverCard. Trigger and item ride the cascade (l2 / l1).
    content: {
      borderRadius: "l3",
    },
    item: {
      _highlighted: {
        bg: {
          base: "bg.emphasized/80",
          _dark: "gray.800",
        },
      },
    },
  },

  variants: {
    variant: {
      outline: {},
      subtle: {
        trigger: {
          borderWidth: "1px",
          borderColor: "transparent",
          bg: "bg.muted",
        },
      },
      ghost: {
        root: {
          width: "fit-content",
        },
        trigger: {
          borderWidth: "1px",
          borderColor: "transparent",
          bg: "transparent",
          _hover: {
            bg: "bg.muted",
          },
        },
      },
      inline: {
        root: {
          width: "fit-content",
        },
        content: {
          minWidth: "fit-content",
        },
        trigger: {
          borderRadius: 0,
          border: "none",
          bg: "inherit",
          pl: 0,
          pr: 7,
          fontSize: "normal",
        },
        valueText: {
          maxWidth: "100%",
        },
      },
    },
  },

  defaultVariants: {
    variant: "outline",
  },
});
